import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    GUIDE_LIST: window.localStorage.getItem('GUIDE_LIST'),
    PROJECT_ID: window.localStorage.getItem('PROJECT_ID'),
    QR_CODE: window.localStorage.getItem('QR_CODE'),
    SHOW_LOCAL_NAME: window.localStorage.getItem('SHOW_LOCAL_NAME'),
    DOC_AREA: '',
    USER_ID: '',
    USER_NAME: '',
    USER_GOOGLE_ID: '',
    USER_GOOGLE_NAME: '',
    USER_GOOGLE_EMAIL: '',
    USER_GOOGLE_IMG_URL: '',
    USER_MOBILE_NUMBER: '',
    USER_GENDER: '',
    USER_AGE_RANGE: '',
    EVENT_URL: window.localStorage.getItem('projectOfficialSite'),
    SERVICE_URL: '',
    API_HOST_URL: 'https://api.y2services.com/v1/',
    API_GUIDES_URL: 'https://api.y2services.com/v1/guide/projectCode/',
    API_USER_SAVE_URL: '',
    API_USER_LOG_LOG: '',
    EXT_CUSTOM_INIT_LON: '',
    EXT_CUSTOM_INIT_LAT: '',
    EXT_CUSTOM_PUB_UTILS: window.localStorage.getItem('EXT_CUSTOM_PUB_UTILS'),
    ALL_MARKERS: window.localStorage.getItem('ALL_MARKERS'),
    LAT: '',
    LON: '',
    GPS_PROC_ID: '',
    IS_TRACKING_ALLOWED: window.localStorage.getItem('IS_TRACKING_ALLOWED')
  },
  getters: {
    getGuides (state) {
      return state.GUIDE_LIST
    },
    getProjectId (state) {
      return state.PROJECT_ID
    },
    getQRCode (state) {
      return state.QR_CODE
    },
    getDocArea (state) {
      return state.DOC_AREA
    },
    getUserId (state) {
      return state.USER_ID
    },
    getUserName (state) {
      return state.USER_NAME
    },
    getUserGoogleName (state) {
      return state.USER_GOOGLE_NAME
    },
    getUserGoogleEmail (state) {
      return state.USER_GOOGLE_EMAIL
    },
    getUserGoogleImgUrl (state) {
      return state.USER_GOOGLE_IMG_URL
    },
    getUserGoogleId (state) {
      return state.USER_GOOGLE_ID
    },
    getUserGender (state) {
      return state.USER_GENDER
    },
    getUserMobileNumber (state) {
      return state.USER_MOBILE_NUMBER
    },
    getUserAgeRange (state) {
      return state.USER_AGE_RANGE
    },
    getEventUrl (state) {
      return state.EVENT_URL
    },
    getServiceUrl (state) {
      return state.SERVICE_URL
    },
    getApiHostUrl (state) {
      return state.API_HOST_URL
    },
    getApiGuidesUrl (state) {
      return state.API_GUIDES_URL
    },
    getApiUserSaveUrl (state) {
      return state.API_USER_SAVE_URL
    },
    getApiUserLogUrl (state) {
      return state.API_USER_LOG_LOG
    },
    getLat (state) {
      return state.LAT
    },
    getLon (state) {
      return state.LON
    },
    getGpsProcId (state) {
      return state.GPS_PROC_ID
    },
    getExtCustomInitLon (state) {
      return state.EXT_CUSTOM_INIT_LON
    },
    getExtCustomInitLat (state) {
      return state.EXT_CUSTOM_INIT_LAT
    },
    getExtCustomPubUtils (state) {
      return state.EXT_CUSTOM_PUB_UTILS
    },
    getIsTrackingAllowed (state) {
      return state.IS_TRACKING_ALLOWED
    },
    getAllMarkers (state) {
      return state.ALL_MARKERS
    },
    getShowLocalName (state) {
      return state.SHOW_LOCAL_NAME
    }
  },
  mutations: {
    setChange (state, msg) {
      switch (msg) {
        case 'SET_PROJECT_ID':
          state.PROJECT_ID = this.getters.getProjectId
          break
        case 'SET_QR_CODE':
          state.QR_CODE = this.getters.getQRCode
          break
        case 'SET_USER_GENDER':
          state.USER_GENDER = this.getters.getUserGender
          break
        case 'USER_AGE_RANGE':
          state.USER_AGE_RANGE = this.getters.getUserAgeRange
          break
        case 'USER_NAME':
          state.USER_NAME = this.getters.getUserName
          break
        case 'GUIDE_LIST':
          state.GUIDE_LIST = this.getters.getGuides
          break
        case 'DOC_AREA':
          state.DOC_AREA = this.getters.getDocArea
          break
        case 'USER_ID':
          state.USER_ID = this.getters.getUserId
          break
        case 'USER_GOOGLE_NAME':
          state.USER_GOOGLE_NAME = this.getters.getUserGoogleName
          break
        case 'USER_GOOGLE_ID':
          state.USER_GOOGLE_ID = this.getters.getUserGoogleId
          break
        case 'USER_GOOGLE_IMG_URL':
          state.USER_GOOGLE_IMG_URL = this.getters.getUserGoogleImgUrl
          break
        case 'USER_GOOGLE_EMAIL':
          state.USER_GOOGLE_EMAIL = this.getters.getUserGoogleEmail
          break
        case 'USER_MOBILE_NUMBER':
          state.USER_MOBILE_NUMBER = this.getters.getUserMobileNumber
          break
        case 'EXT_CUSTOM_INIT_LON':
          state.EXT_CUSTOM_INIT_LON = this.getters.getExtCustomInitLon
          break
        case 'EXT_CUSTOM_INIT_LAT':
          state.EXT_CUSTOM_INIT_LAT = this.getters.getExtCustomInitLat
          break
        case 'EXT_CUSTOM_PUB_UTILS':
          state.EXT_CUSTOM_PUB_UTILS = this.getters.getExtCustomPubUtils
          break
        case 'IS_TRACKING_ALLOWED':
          state.IS_TRACKING_ALLOWED = this.getters.getIsTrackingAllowed
          break
        case 'ALL_MARKERS':
          state.ALL_MARKERS = this.getters.getAllMarkers
          break
        case 'SHOW_LOCAL_NAME':
          state.SHOW_LOCAL_NAME = this.getters.getShowLocalName
          break
        default:
      }
    },
    setProjectId (state, prjId) {
      window.localStorage.setItem('PROJECT_ID', prjId)
      state.PROJECT_ID = prjId
      this.commit('setChange', 'SET_PROJECT_ID')
    },
    setQRCode (state, qrCode) {
      window.localStorage.setItem('QR_CODE', qrCode)
      state.QR_CODE = qrCode
      this.commit('setChange', 'SET_QR_CODE')
    },
    setUserGender (state, gender) {
      state.USER_GENDER = gender
      this.commit('setChange', 'SET_USER_GENDER')
    },
    setUserAgeRange (state, ageRange) {
      state.USER_AGE_RANGE = ageRange
      this.commit('setChange', 'USER_AGE_RANGE')
    },
    setDocArea (state, docArea) {
      state.DOC_AREA = docArea
      this.commit('setChange', 'DOC_AREA')
    },
    setUserId (state, userId) {
      state.USER_ID = userId
      this.commit('setChange', 'USER_ID')
    },
    setUserGoogleName (state, userGoogleName) {
      state.USER_GOOGLE_NAME = userGoogleName
      this.commit('setChange', 'USER_GOOGLE_NAME')
    },
    setUserGoogleId (state, userGoogleId) {
      state.USER_GOOGLE_ID = userGoogleId
      this.commit('setChange', 'USER_GOOGLE_ID')
    },
    setUserGoogleImgUrl (state, userGoogleImgUrl) {
      state.USER_GOOGLE_IMG_URL = userGoogleImgUrl
      this.commit('setChange', 'USER_GOOGLE_IMG_URL')
    },
    setUserGoogleEmail (state, userGoogleEmail) {
      state.USER_GOOGLE_EMAIL = userGoogleEmail
      this.commit('setChange', 'USER_GOOGLE_EMAIL')
    },
    setUserMobileNumber (state, userMobileNumber) {
      state.USER_MOBILE_NUMBER = userMobileNumber
      this.commit('setChange', 'USER_MOBILE_NUMBER')
    },
    setUserName (state, userName) {
      state.USER_NAME = userName
      this.commit('setChange', 'USER_NAME')
    },
    reloadGuides (state, obj) {
      window.localStorage.setItem('GUIDE_LIST', obj)
      state.guideList = obj
      this.commit('setChange', 'GUIDE_LIST')
    },
    setExtCustomInitLon (state, obj) {
      state.EXT_CUSTOM_INIT_LON = obj
      this.commit('setChange', 'EXT_CUSTOM_INIT_LON')
    },
    setExtCustomInitLat (state, obj) {
      state.EXT_CUSTOM_INIT_LAT = obj
      this.commit('setChange', 'EXT_CUSTOM_INIT_LAT')
    },
    setExtCustomPubUtils (state, obj) {
      window.localStorage.setItem('EXT_CUSTOM_PUB_UTILS', obj)
      state.EXT_CUSTOM_PUB_UTILS = obj
      this.commit('setChange', 'EXT_CUSTOM_PUB_UTILS')
    },
    setIsTrackingAllowed (state, obj) {
      window.localStorage.setItem('IS_TRACKING_ALLOWED', obj)
      this.commit('setChange', 'IS_TRACKING_ALLOWED')
    },
    setAllMarkers (state, obj) {
      window.localStorage.setItem('ALL_MARKERS', obj)
      this.commit('setChange', 'ALL_MARKERS')
    },
    setShowLocalName (state, obj) {
      window.localStorage.setItem('SHOW_LOCAL_NAME', obj)
      this.commit('setChange', 'SHOW_LOCAL_NAME')
    }
  },
  modules: {
  }
})
